<template>
  <div class="row">
    <div class="col-md-12">
      <createCompanyModal
        v-if="createCompanyModalVisible"
        v-on:close="closeModal"
      />

      <h5>Deal {{ index + 1 }}</h5>
      <div class="row">
        <div class="form-group col-md-4">
          <label style="margin-left: 0px;">Amount</label>
          <p>Amount of funding invested</p>
          <div class="form-group input-group" style="width: 200px;">
            <span style="background: white;" class="input-group-addon"
              ><span>$</span>
            </span>
            <input
              class="form-control"
              v-model="amount"
              type="number"
              placeholder="Amount"
              required
            />
          </div>
        </div>

        <div class="form-group col-md-4">
          <label style="margin-left: 0px;">Year</label>
          <p>Year deal was completed</p>
          <div class="form-group input-group" style="width: 200px;">
            <select
              style="margin: 0px; border-top-left-radius: 0px;"
              class="form-control"
              :value="year"
              @input="setDate"
              required
            >
              <option :value="null">Select year</option>
              <option v-for="year in yearRange">{{ year }}</option>
            </select>
          </div>
        </div>

        <div>
          <div class="form-group col-md-4">
            <label style="margin-left: 0px;"
              >Source <small>(optional)</small></label
            >
            <p>Link to news story or press release</p>
            <div class="form-group input-group" style="width: 200px;">
              <input
                class="form-control"
                v-model="source"
                type="url"
                placeholder="https://crunchbase.com"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>Investees</label>
          <p>
            Please add companies from this deal. Create a new company if it does
            not already exist.
          </p>
          <div style="background: 1px solid black; display: inline-block">
            <div
              v-for="(company, index) in selectedCompaniesFromStore"
              class="badge prop-badge"
            >
              {{ getFirst10(company.name) }}
              <button
                class="close-badge"
                style="border: 0px; margin: 0px; padding: 0px;"
                type="button"
                v-on:click="methodToRunOnSelect(company, 'selectedCompanies')"
              >
                <span
                  aria-hidden="true"
                  style="font-size: 20px; color: #d82d14;"
                  >&times;</span
                >
              </button>
            </div>
          </div>

          <div class="dropdown">
            <button
              name="dropbtn"
              class="options dropbtn btn-create"
              style="padding-top: 2px;padding-bottom: 2px;"
              v-on:click="toggleCompanyDropdown()"
            >
              Add investees
            </button>
            <div v-if="companyDropdownVisible" style="top: 40px; left: -80px;">
              <div class="overlay" v-on:click="toggleCompanyDropdown()" />
              <div class="modal-content" style="max-height: 400px;">
                <div class="form-group input-group" style="margin-bottom:0px;">
                  <span
                    style="background: white; border-width: 0px 0px 1px 0px; border-radius: 0px; font-size: 10px;"
                    class="input-group-addon"
                    ><i class="fa fa-search icon"></i
                  ></span>
                  <input
                    type="text"
                    style="width: 100%; margin: 0px; border-radius: 0px; border-width: 0px 0px 1px 0px;"
                    placeholder="search"
                    v-model="companySearchQuery"
                    class="form-group input-group"
                  />
                </div>

                <button
                  type="button"
                  style="width: 100%; margin: 0px;"
                  class="form-group input-group btn-create"
                  v-on:click="createCompanyModalToggle()"
                >
                  Create new company
                </button>

                <div
                  v-for="letterCollection in searchedCompanies"
                  v-if="letterCollection.array.length > 0"
                >
                  <input
                    v-for="company in letterCollection.array"
                    type="button"
                    class="btn-default"
                    style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
                    :value="company.name"
                    v-bind:class="{
                      selected: isSelected(company, 'selectedCompanies')
                    }"
                    v-on:click="
                      methodToRunOnSelect(company, 'selectedCompanies')
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label>Co-Investors</label>
          <p>
            Please add companies from this deal. Create a new company if it does
            not already exist.
          </p>
          <div style="background: 1px solid black; display: inline-block">
            <div
              v-for="(provider, index) in selectedProvidersFromStore"
              class="badge prop-badge"
            >
              {{ getFirst10(provider.name) }}
              <button
                v-if="!isCurrentProvider(provider.id)"
                class="close-badge"
                type="button"
                style="border: 0px; margin: 0px; padding: 0px;"
                v-on:click="methodToRunOnSelect(provider, 'selectedProviders')"
              >
                <span
                  aria-hidden="true"
                  style="font-size: 20px; color: #d82d14;"
                  >&times;</span
                >
              </button>
            </div>
          </div>

          <div class="dropdown">
            <button
              name="dropbtn"
              class="options dropbtn btn-create"
              style="padding-top: 2px;padding-bottom: 2px;"
              v-on:click="toggleProviderDropdown()"
            >
              Add co-investors
            </button>
            <div v-if="providerDropdownVisible">
              <div class="overlay" v-on:click="toggleProviderDropdown()" />
              <div class="modal-content" style="max-height: 400px;">
                <div class="form-group input-group">
                  <span
                    style="background: white; border-width: 0px 0px 1px 0px; border-radius: 0px; font-size: 10px;"
                    class="input-group-addon"
                    ><i class="fa fa-search icon"></i
                  ></span>
                  <input
                    type="text"
                    style="width: 100%; margin: 0px; border-radius: 0px; border-width: 0px 0px 1px 0px;"
                    placeholder="search"
                    v-model="providerSearchQuery"
                    class="form-group input-group"
                  />
                </div>
                <div
                  v-for="letterCollection in searchedProviders"
                  v-if="letterCollection.array.length > 0"
                >
                  <h4>
                    {{ letterCollection.letter }}
                  </h4>
                  <input
                    v-for="provider in letterCollection.array"
                    v-if="!isCurrentProvider(provider.id)"
                    type="button"
                    class="btn-default"
                    style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
                    :value="provider.name"
                    v-bind:class="{
                      selected: isSelected(provider, 'selectedProviders')
                    }"
                    v-on:click="
                      methodToRunOnSelect(provider, 'selectedProviders')
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="float: right;">
          <button
            class="btn-default btn-delete"
            style="margin-top: 0px; margin-left: 0px;"
            type="button"
            @click="removeDeal()"
          >
            Remove deal
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import utils from "../components/utils.js";
import createCompanyModal from "../elements/createCompanyModal.vue";

export default {
  name: "deal-page",
  props: {
    index: Number
  },
  components: {
    createCompanyModal: createCompanyModal
  },
  data() {
    return {
      selectedProviders: [],
      providerSearchQuery: "",
      companyArray: [],
      selectedCompanies: [],
      companySearchQuery: "",
      providerArray: [],
      createCompanyModalVisible: false,
      currentProviderId: undefined,
      companyDropdownVisible: false,
      providerDropdownVisible: false
    };
  },
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain",
      companies: "companies",
      providers: "providerList"
    }),
    yearRange: function() {
      return utils.yearRange();
    },
    searchedCompanies: function() {
      if (this.companySearchQuery != "") {
        var filteredArray = this.companyArray.map(collection => {
          return {
            letter: collection.letter,
            array: collection.array.filter(item => {
              return (
                item.name
                  .toLowerCase()
                  .indexOf(this.companySearchQuery.toLowerCase()) > -1
              );
            })
          };
        });
        return filteredArray;
      } else {
        return this.companyArray;
      }
    },
    searchedProviders: function() {
      if (this.providerSearchQuery != "") {
        var filteredArray = this.providerArray.map(collection => {
          return {
            letter: collection.letter,
            array: collection.array.filter(item => {
              return (
                item.name
                  .toLowerCase()
                  .indexOf(this.providerSearchQuery.toLowerCase()) > -1
              );
            })
          };
        });
        return filteredArray;
      } else {
        return this.providerArray;
      }
    },
    amount: {
      set: function(editedData) {
        var payl = {
          data: editedData,
          keyChain: ["relationships", this.index, "jdoc", "amount"]
        };
        this.setEditedProviderByKeyChain(payl);
      },
      get: function() {
        return this.getProperty([
          "relationships",
          this.index,
          "jdoc",
          "amount"
        ]);
      }
    },
    year: {
      set: function(editedData) {
        var payl = {
          data: editedData,
          keyChain: ["relationships", this.index, "jdoc", "year"]
        };
        this.setEditedProviderByKeyChain(payl);
      },
      get: function() {
        return this.getProperty(["relationships", this.index, "jdoc", "year"]);
      }
    },
    source: {
      set: function(editedData) {
        var payl = {
          data: editedData,
          keyChain: ["relationships", this.index, "jdoc", "source"]
        };
        this.setEditedProviderByKeyChain(payl);
      },
      get: function() {
        return this.getProperty([
          "relationships",
          this.index,
          "jdoc",
          "source"
        ]);
      }
    },
    selectedCompaniesFromStore: function() {
      var selectedCompaniesId = this.getProperty([
        "relationships",
        this.index,
        "jdoc",
        "investees"
      ]);

      selectedCompaniesId =
        selectedCompaniesId == undefined ? [] : selectedCompaniesId;
      return selectedCompaniesId.map(companyId => {
        return this.companies.find(company => {
          return company.id == companyId;
        });
      });
    },
    selectedProvidersFromStore: function() {
      var selectedProvidersId = this.getProperty([
        "relationships",
        this.index,
        "jdoc",
        "investors"
      ]);

      selectedProvidersId =
        selectedProvidersId == undefined ? [] : selectedProvidersId;

      return selectedProvidersId.map(providerId => {
        var selectedProvider = this.providers.find(provider => {
          return provider.id == providerId;
        });
        return selectedProvider == undefined
          ? this.getProperty([])
          : selectedProvider;
      });
    }
  },
  created() {
    this.sortByLetter();
    var jdoc = this.getProperty(["relationships", this.index, "jdoc"]);
    this.selectedCompanies = jdoc.investees.map(id => {
      return this.companies.find(c => c.id == id);
    });
    this.selectedProviders = jdoc.investors.map(id => {
      var selectedP = this.providers.find(p => p.id == id);
      return selectedP == undefined ? this.getProperty([]) : selectedP;
    });
    this.currentProviderId = this.getProperty(["id"]);
  },
  methods: {
    ...mapMutations({
      deleteProviderProperty: "deleteEditedProviderPropertyByKeyChain",
      setEditedProviderByKeyChain: "setEditedProviderByKeyChain"
    }),
    sortByLetter() {
      this.companyArray = [];
      this.providerArray = [];
      const alphabet = utils.alphabet();
      for (var letter of alphabet) {
        this.companyArray.push({
          letter: letter,
          array: utils.arrangeListByLetter(this.companies, letter)
        });
        this.providerArray.push({
          letter: letter,
          array: utils.arrangeListByLetter(this.providers, letter)
        });
      }
    },
    setDate(editedData) {
      var payl = {
        data: editedData.target.value,
        keyChain: ["relationships", this.index, "jdoc", "year"]
      };
      this.setEditedProviderByKeyChain(payl);
    },

    toggleCompanyDropdown() {
      this.companyDropdownVisible = !this.companyDropdownVisible;
    },
    toggleProviderDropdown() {
      this.providerDropdownVisible = !this.providerDropdownVisible;
    },
    createCompanyModalToggle() {
      this.createCompanyModalVisible = !this.createCompanyModalVisible;
      this.toggleCompanyDropdown();
    },
    isCurrentProvider(id) {
      return this.currentProviderId == id;
    },
    getFirst10: function(str) {
      if (str.length > 9) {
        return str.substring(0, 10) + "...";
      } else {
        return str;
      }
    },
    removeDeal: function() {
      this.deleteProviderProperty(["relationships", this.index]);
    },
    methodToRunOnSelect(item, type) {
      if (this[type].includes(item)) {
        var i = this[type].indexOf(item);
        this[type].splice(i, 1);
      } else {
        this[type].push(item);
      }

      var allIds = [
        ...this.selectedCompanies.map(item => {
          return item.id;
        }),
        ...this.selectedProviders.map(item => {
          return item.id;
        })
      ];

      var payl = {
        data: allIds,
        keyChain: ["relationships", this.index, "object_ids"]
      };
      this.setEditedProviderByKeyChain(payl);

      var payl = {
        data: this.selectedCompanies.map(item => item.id),
        keyChain: ["relationships", this.index, "jdoc", "investees"]
      };
      this.setEditedProviderByKeyChain(payl);

      var payl = {
        data: this.selectedProviders.map(item => item.id),
        keyChain: ["relationships", this.index, "jdoc", "investors"]
      };
      this.setEditedProviderByKeyChain(payl);
    },
    isSelected(item, type) {
      return this[type].indexOf(item) > -1;
    },
    closeModal(id) {
      this.createCompanyModalVisible = !this.createCompanyModalVisible;
      if (id) {
        this.sortByLetter();
        var company = this.companies.find(item => item.id == id);
        this.methodToRunOnSelect(company, "selectedCompanies");
      }
    }
  }
};
</script>

<style scoped>
.selected {
  color: lightgrey;
}

.dropbtn {
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  width: 600px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  left: -160px;
  top: -400px;
}

.modal-content {
  position: fixed;
  z-index: 100;
  padding-top: 200px;
  left: 40.75%;
  top: 100px;
  width: 37.5%;
  background-color: #fefefe;
  margin: auto;
  padding: 0px;
  border: 1px solid #888;
  max-height: 60vh;
  overflow: scroll;
}

button {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 6px;
  margin-bottom: 16px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #eaeaea;
}

input[type="text"] {
  width: 200px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}

.overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/elements/dealInputForm.vue